var _desc, _defs, _rect, _circle, _g, _g2, _g3, _g4, _text, _text2, _text3, _line, _circle2, _path, _g5, _g6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSrsapp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 450",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "srsTitle"
  }, "SRS App") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "srsTitle"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "srsDesc"
  }, "A flashcard with a kanji prompt and typed answer on washi paper, with sakura petals and a spaced-repetition stage ladder.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "srsShadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 6,
    stdDeviation: 8,
    floodColor: "#8a7a5c",
    floodOpacity: 0.28
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 450,
    fill: "#f7f1e5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 200,
    r: 158,
    fill: "#e05545",
    opacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f2a8bc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96 84 C104 70 118 70 122 84 C126 96 112 108 108 100 C104 108 92 96 96 84 Z",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690 66 C698 52 712 52 716 66 C720 78 706 90 702 82 C698 90 686 78 690 66 Z",
    opacity: 0.7,
    transform: "rotate(40 703 71)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714 300 C722 286 736 286 740 300 C744 312 730 324 726 316 C722 324 710 312 714 300 Z",
    opacity: 0.8,
    transform: "rotate(-30 727 305)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 322 C84 308 98 308 102 322 C106 334 92 346 88 338 C84 346 72 334 76 322 Z",
    opacity: 0.6,
    transform: "rotate(70 89 327)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148 208 C154 198 164 198 167 208 C170 217 160 226 157 220 C154 226 145 217 148 208 Z",
    opacity: 0.5,
    transform: "rotate(15 157 212)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652 180 C658 170 668 170 671 180 C674 189 664 198 661 192 C658 198 649 189 652 180 Z",
    opacity: 0.5,
    transform: "rotate(-50 661 184)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-5 400 178)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 254,
    y: 66,
    width: 292,
    height: 212,
    rx: 14,
    fill: "#fffdf8",
    stroke: "#d9cdb8",
    strokeWidth: 2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(4 400 178)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 254,
    y: 66,
    width: 292,
    height: 212,
    rx: 14,
    fill: "#fffdf8",
    stroke: "#d9cdb8",
    strokeWidth: 2
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#srsShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 70,
    width: 296,
    height: 214,
    rx: 14,
    fill: "#fffefb",
    stroke: "#3a332c",
    strokeWidth: 2.5
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 278,
    y: 104,
    fontFamily: "Consolas, ui-monospace, monospace",
    fontSize: 14,
    fontWeight: 600,
    fill: "#c24837"
  }, "kanji \xB7 N5")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 196,
    textAnchor: "middle",
    fontFamily: "'Yu Gothic UI', 'Yu Gothic', 'Hiragino Sans', 'Noto Sans CJK JP', sans-serif",
    fontSize: 84,
    fontWeight: 700,
    fill: "#2a2420"
  }, "\u5B66")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 352,
    y: 248,
    fontFamily: "'Yu Gothic UI', 'Yu Gothic', 'Hiragino Sans', 'Noto Sans CJK JP', sans-serif",
    fontSize: 22,
    fill: "#c24837"
  }, "\u304C\u304F")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 294,
    y1: 258,
    x2: 462,
    y2: 258,
    stroke: "#3a332c",
    strokeWidth: 2.5,
    opacity: 0.75
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 494,
    cy: 250,
    r: 15,
    fill: "#3f9e6e"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M487 250 L492 256 L502 244",
    stroke: "#ffffff",
    strokeWidth: 3.5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 322,
    width: 58,
    height: 12,
    rx: 6,
    fill: "#c24837",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298,
    y: 322,
    width: 58,
    height: 12,
    rx: 6,
    fill: "#c24837",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 322,
    width: 58,
    height: 12,
    rx: 6,
    fill: "#c24837",
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 322,
    width: 58,
    height: 12,
    rx: 6,
    fill: "#c24837",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 502,
    y: 322,
    width: 58,
    height: 12,
    rx: 6,
    fill: "#d4a017"
  }), /*#__PURE__*/React.createElement("text", {
    x: 230,
    y: 352,
    fontFamily: "Consolas, ui-monospace, monospace",
    fontSize: 13,
    fill: "#8f8570"
  }, "new"), /*#__PURE__*/React.createElement("text", {
    x: 560,
    y: 352,
    textAnchor: "end",
    fontFamily: "Consolas, ui-monospace, monospace",
    fontSize: 13,
    fill: "#b3890f"
  }, "burned"))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    x: 386,
    y: 410,
    textAnchor: "middle",
    fontFamily: "'Segoe UI', system-ui, sans-serif",
    fontSize: 30,
    fontWeight: 700,
    fill: "#2a2420"
  }, "SRS App"), /*#__PURE__*/React.createElement("rect", {
    x: 466,
    y: 386,
    width: 30,
    height: 30,
    rx: 4,
    fill: "#c24837"
  }), /*#__PURE__*/React.createElement("text", {
    x: 481,
    y: 409,
    textAnchor: "middle",
    fontFamily: "'Yu Gothic UI', 'Yu Gothic', 'Hiragino Sans', 'Noto Sans CJK JP', sans-serif",
    fontSize: 20,
    fontWeight: 700,
    fill: "#fffefb"
  }, "\u8A18"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSrsapp);
export default __webpack_public_path__ + "static/media/srsapp.d4be4f925f9ff826f7fcdc067a2f9262.svg";
export { ForwardRef as ReactComponent };